module.exports = __webpack_public_path__ + "static/media/Daniele Grandi.899507fa.png";